import { createAsyncThunk } from '@reduxjs/toolkit'
import { SERVICE_D2D } from 'app/commons/constants'
import { hideLoading, showLoading } from 'app/commons/helpers/loadingUtils'
import { IRequestBookingDetail } from 'app/interface/IBooking'
import bookingApi from 'app/services/bookingApi'

import { bookingAction } from '../booking/bookingSlice'
import { informationCreateActions } from '../information/informationSlice'
import { locationsAction } from '../locations/locationSlice'
import { portsAction } from '../locations/portsSlice'

const getBookingDetails = createAsyncThunk(
  'bookingDetails/getBookingDetails',
  async (data: IRequestBookingDetail, thunkAPI) => {
    try {
      const { callback, id, isShowLoading } = data
      if (isShowLoading) {
        showLoading()
      }
      const bookingVersion = await bookingApi.getVersionBooking(id)
      const result = await bookingApi.getBookingDetails(id, bookingVersion)
      const { items, pickupAddress, destinationAddresses, schedule, serviceType } = result.data
      const listPorts = [pickupAddress.port, destinationAddresses[0].port]
      const locations = [
        {
          isPickup: true,
          address: serviceType === SERVICE_D2D ? pickupAddress.address : pickupAddress.port.portNameId,
          location: {
            index: 0,
            latitude:
              serviceType === SERVICE_D2D ? pickupAddress.location.latitude : pickupAddress.port.location.latitude,
            longitude:
              serviceType === SERVICE_D2D ? pickupAddress.location.longitude : pickupAddress.port.location.longitude,
          },
          portId: pickupAddress?.port?.unPortId,
          jsonAddress: pickupAddress?.jsonAddress,
        },
        {
          isPickup: false,
          address: destinationAddresses[0].address,
          location: {
            index: 1,
            latitude: destinationAddresses[0].location.latitude,
            longitude: destinationAddresses[0].location.longitude,
          },
          jsonAddress: destinationAddresses[0]?.jsonAddress,
        },
      ]
      thunkAPI.dispatch(portsAction.updateListPorts(listPorts))
      thunkAPI.dispatch(bookingAction.updateFieldBooking({ field: 'schedule', value: schedule }))
      thunkAPI.dispatch(locationsAction.updateServiceType(serviceType))
      thunkAPI.dispatch(locationsAction.updateListLocations(locations))
      thunkAPI.dispatch(informationCreateActions.setInitInfo(items))
      callback && callback(result.data)
      hideLoading()
      return result.data
    } catch (ex) {
      hideLoading()
      window.location.replace('/')
      console.error(ex)
    }
  }
)

const bookingDetailsAction = {
  getBookingDetails,
}
export default bookingDetailsAction
